import React from 'react';
import { useSelector } from 'react-redux';
import UnhandledErrorContainer from '~/components/containers/UnhandledErrorContainer/UnhandledErrorContainer';
import AcceptCookiesContainer from '~/components/containers/AcceptCookiesContainer/AcceptCookiesContainer';
import OldVersionWarning from '~/components/views/OldVersionWarning/OldVersionWarning';
import InfoModalContainer from '~/components/containers/InfoModalContainer/InfoModalContainer';
import AppSwitch from '~/components/containers/AppContainer/components/AppSwitch';
import AndroidInstallBanner from '~/domain/install-prompt/components/AndroidInstallBanner/AndroidInstallBanner';
import IOSInstallBanner from '~/domain/install-prompt/components/IOSInstallBanner/IOSInstallBanner';
import IncidentBanner from '~/core/components/incident-communication/components/IncidentBanner/IncidentBanner';
import { StatusMode } from '~/core/components/incident-communication/models/AppStatusConfig';
import type { AppState } from '~/reducers';
import * as S from './styled';
export interface Props {
  landingPage: string;
  setShowOldVersionWarning(showOldVersion: boolean): void;
  showOldVersionWarning: boolean;
  isInfoModalOpen: boolean;
}

const App = ({
  showOldVersionWarning,
  setShowOldVersionWarning,
  isInfoModalOpen,
  landingPage,
}: Props) => {
  const onWebView = useSelector((state: AppState) => state.native.onWebView);
  const notOnWebView = onWebView === false;
  return (
    <S.App data-testid="app">
      {notOnWebView && <IncidentBanner statusMode={StatusMode.GlobalMaintenanceBanner} />}
      {notOnWebView && <AndroidInstallBanner />}
      {notOnWebView && <IOSInstallBanner />}
      {notOnWebView && <AcceptCookiesContainer />}
      {notOnWebView && showOldVersionWarning && (
        <OldVersionWarning setShowOldVersionWarning={setShowOldVersionWarning} />
      )}
      {isInfoModalOpen && <InfoModalContainer />}
      <AppSwitch landingPage={landingPage} />
      <UnhandledErrorContainer />
    </S.App>
  );
};

export default App;
